export const CHECK_DEPOSIT_UNIT_STATUS = {
  AWAITING_IMAGES: 'AwaitingImages',
  AWAITING_FRONT_IMAGE: 'AwaitingFrontImage',
  AWAITING_BACK_IMAGE: 'AwaitingBackImage',
  PENDING: 'Pending',
  PENDING_REVIEW: 'PendingReview',
  REJECTED: 'Rejected',
  CLEARING: 'Clearing',
  SENT: 'Sent',
  CANCELED: 'Canceled',
  RETURNED: 'Returned',
  AWAITING_CUSTOMER_CONFIRMATION: 'AwaitingCustomerConfirmation'
};
